import cloneDeep from 'lodash/cloneDeep';
import authStore from '../../stores/auth';
export const defaultFilters = {
    favorite_membership: {
        membership_owner_id: null,
        status: true,
        isFavorite: null,
    },
    profile: {
        addresses: [],
        citizenship: [],
        activities: [],
        skills: [],
        jobStatuses: [],
        lifts: [],
        ageGt: null,
        ageLt: null,
        government: null,
        fromSalary: null,
        toSalary: null,
        gender: null,
        volunteerWork: null,
        socialWork: null,
        withDrafts: null,
        withRsvMobileApp: null,
        registrationDateFrom: null,
        registrationDateTo: null,
        importantFieldsFilled: null,
    },
    language: {
        language: null,
        languageLevel: null,
    },
    nominations: {
        projectsTypes: [],
        rootProjects: [],
        projects: [],
        excludeProjects: [],
        participantStatuses: [],
        seasons: [],
        excludeSeasonsList: [],
        projectRegisteredAtDateFrom: null,
        projectRegisteredAtDateTo: null,
        nominationRegisteredAtDateFrom: null,
        nominationRegisteredAtDateTo: null,
    },
    education: {
        educationLevels: [],
        educationPlaces: [],
        educationSpecialties: [],
        educationDegrees: [],
    },
    career: {
        levels: [],
    },
    progress: {
        competence: [],
        levels: [],
    },
    course: {
        courseDateFrom: null,
        courseDateTo: null,
        foreign_institutes_id: [],
        event_id: [],
        courseStatus: [],
        excludeEventId: [],
    },
};

export function getDefaultFilters() {
    defaultFilters.favorite_membership.membership_owner_id = authStore.state.user.id;
    return cloneDeep(defaultFilters);
}
